import { pages } from 'src/assets/common/tables/pages.g';
import { TPageName } from 'src/assets/common/enums/page-name.g';

// De Pages-tabel exporteert Name in PascalCase (ruwe DB-kolom), terwijl de pageName-keys camelCase
// zijn (eerste letter klein). Normaliseer beide kanten naar eerste-letter-klein zodat de lookup matcht.
const __norm = (s: string): string => (s ? s.charAt(0).toLowerCase() + s.slice(1) : s);

// Lookup van de gegenereerde Pages-tabel (genormaliseerde name → row). Eénmalig; de tabel is statisch.
const __byName = new Map(pages.map(p => [__norm(p.name), p]));

// Verkort label voor compacte UI (bv. nav-history). IconName is bedoeld als verkorte omschrijving;
// is die leeg, dan de volledige DisplayName, en als laatste redmiddel de ruwe paginanaam.
export function pageShortLabel(name: TPageName | string): string {
    const __row = __byName.get(__norm(String(name)));
    return __row?.iconName || __row?.displayName || String(name);
}

// Volledig label: DisplayName, anders de ruwe paginanaam.
export function pageDisplayName(name: TPageName | string): string {
    const __row = __byName.get(__norm(String(name)));
    return __row?.displayName || String(name);
}
